// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 查询分页
 * @param params
 * @returns {*}
 */
export function myMenu(params) {
  return axios.get('/home/system/menu').then(res => res.data);
}
/**
 * 查询分页
 * @param params
 * @returns {*}
 */
export function pageAdmin(params) {
  return axios.get('/system/admin', {params: params}).then(res => res.data);
}
/**
 * 重置密码
 * @returns {*}
 */
export function resetPassword(userId) {
  return axios.post('/system/admin/resetPassword/' + userId).then(res => res.data);
}
/**
 * 增加用户
 * @returns {*}
 */
export function addAdmin(data) {
  return axios.post('/system/admin', data).then(res => res.data);
}
/**
 * 保存管理员角色关联
 * @param data
 * @returns {*}
 */
export function saveAdminRole(data) {
  return axios.post('/system/admin/saveAdminRole', data).then(res => res.data);
}
/**
 * 根据管理员id查角色
 * @param adminId
 * @returns {*}
 */
export function listRoleIdByAdminId(adminId) {
  return axios.get('/system/admin/listRoleIdByAdminId/' + adminId).then(res => res.data);
}
/**
 * 菜单列表
 * @returns {*}
 */
export function listMenu() {
  return axios.get('/system/menu/menuTreeList').then(res => res.data);
}
/**
 * 角色列表
 * @param params
 * @returns {*}
 */
export function listRole(params) {
  return axios.get('/system/role', {params: params}).then(res => res.data);
}
/**
 * 保存角色
 * @param data
 * @returns {*}
 */
export function saveRole(data) {
  return axios.post('/system/role', data).then(res => res.data);
}
/**
 * 保存角色菜单关联
 * @param data
 * @returns {*}
 */
export function saveRoleMenu(data) {
  return axios.post('/system/role/saveRoleMenu', data).then(res => res.data);
}
/**
 * 删除角色
 * @param roleId
 * @returns {*}
 */
export function deleteRole(roleId) {
  return axios.post('/system/role/delete/' + roleId).then(res => res.data);
}
/**
 * 查询角色拥有的菜单列表
 * @param roleId
 * @returns {*}
 */
export function listMenuIdByRoleId(roleId) {
  return axios.get('/system/menu/listMenuIdByRoleId/' + roleId).then(res => res.data);
}
/**
 * 微信推送
 * @param params
 * @returns {*}
 */
export function pushWechat(params) {
  return axios.get('/system/admin/pushWechat', {params: params}).then(res => res.data);
}

/**
 * 删除菜单
 * @param menuId
 * @returns {*}
 */
export function deleteMenu(menuId) {
  return axios.post('/sysMenu/delete?id=' + menuId).then(res => res.data);
}

/**
 * 保存或更新菜单
 * @param data
 * @returns {*}
 */
export function saveOrUpdateMenu(data) {
  return axios.post('/system/menu/saveOrUpdate', data).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/sys.js